<template>
<div class="main-container">
    <div class="inner-container">
        <signed-in-user-info :user="user" :userData="userData" :loadingUser="loadingUser"/>
        <div class="track-shipment update-user">
            <div class="user-info">
                <div class="inner-overflow-container" id="inner-overflow-container">
                        <div class="confirmContainerInner">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1">
                                    <div class="confirm-svg">
                                        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                                            <path d="m9.5,2.5c0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5-1.119,2.5-2.5,2.5-2.5-1.119-2.5-2.5Zm11.368,15.994c-.272.479-.882.646-1.363.375-.032-.019-3.344-1.869-7.505-1.869-4.186,0-7.471,1.85-7.504,1.868-.155.089-.326.132-.495.132-.304,0-.601-.137-.796-.393-.304-.398-.267-.96.088-1.314l3.707-3.707v-2.586c0-2.757,2.243-5,5-5,.732,0,1.451.169,2.109.477l5.184-5.184c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414L7.927,15.488c1.199-.283,2.582-.488,4.073-.488,1.066,0,2.072.108,3,.271v-3.771c0-.552.447-1,1-1s1,.448,1,1v4.234c2.065.596,3.405,1.346,3.496,1.398.479.273.646.883.372,1.362Zm-11.868-6.908l3.518-3.518c-.172-.03-.342-.068-.518-.068-1.654,0-3,1.346-3,3v.586Zm0,7.414c-.553,0-1,.448-1,1v3c0,.552.447,1,1,1s1-.448,1-1v-3c0-.552-.447-1-1-1Zm6,0c-.553,0-1,.448-1,1v3c0,.552.447,1,1,1s1-.448,1-1v-3c0-.552-.447-1-1-1Z"/>
                                        </svg> 
                                        <h2>Create Driver</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="confirmContainerInner">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1">
                                    <div class="confirmLabelContainer">
                                        <input type="text" v-model="driverInput.driverCode" placeholder="Driver Username">
                                    </div>
                                    
                                    <!-- <div class="confirmLabelContainer">
                                        <input type="text" id="driverId" disabled v-model="driverInput.driverId" placeholder="Driver ID">
                                    </div> -->

                                    <div class="confirmLabelContainer">
                                        <input type="text" id="firstName" v-model="driverInput.firstName" placeholder="First Name">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" id="lastName" v-model="driverInput.lastName" placeholder="Last Name">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" id="email" v-model="driverInput.email" placeholder="Email">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <input type="text" id="phoneNumber" v-model="driverInput.phoneNumber" placeholder="Phone Number">
                                    </div>

                                    <div class="confirmLabelContainer">
                                        <select id="vendor" v-model="driverInput.vendor">
                                            <option value="" disabled>
                                                {{ loadingVendors ? "Loading vendors..." : "Select Vendor (required)" }}
                                            </option>

                                            <option
                                                v-for="vendor in vendors"
                                                :key="vendor.vendor"
                                                :value="vendor.vendor"
                                            >
                                                {{ vendor.vendorName ? `${vendor.vendorName} (${vendor.vendor})` : vendor.vendor }}
                                            </option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        
                    </div>
                <button class="update-user-button" @click="CreateDriverItem()">Create Driver</button>
            </div>
        </div>
        <div v-if="(AdminUser || InternalAdmin)" class="track-shipment update-user">
            <driver-table :key="refreshKey" :jwtToken="jwtToken" :userData="userData"/>
        </div>
    </div>
</div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {createDriver} from '../../../graphql/mutations'
import {driverByDriverId} from '../../../graphql/queries'
import {Auth, API} from 'aws-amplify'
import SignedInUserInfo from '../UserDashboard/SignedInUserInfo.vue'
import AlertUser from '../../../components/Popups/AlertUser.vue';
import DriverTable from '../DriverDashboard/DriverTable.vue'

export default {
    data(){
        return{
            user: {},
            jwtToken: null,
            loadingUser: false,
            userData: {},
            toggleAlertBox: false,
            AdminUser: false,
            InternalAdmin: false,
            CreateNewAccount: false,
            Customer: false,
            CustomerAdmin: false,
            ManagePrices: false,
            EditorGroup: false,
            driverInput: {
                driverCode: "",
                driverId: 0,
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                vendor: ""
            },
            vendors: [],
            loadingVendors: false,
            refreshKey: 0,
        }
    },
    components:{
        AlertUser,
        DriverTable,
        SignedInUserInfo
    },
    mounted(){
        this.listVendors();

        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.jwtToken = user.signInUserSession.accessToken.jwtToken;
            this.GetUserGraphQL();

            if(this.user.signInUserSession.idToken.payload['cognito:groups']){
                this.user.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                    if(group == 'Admin'){
                      this.AdminUser = true;
                    }

                    if(group == 'InternalAdmin'){
                        this.InternalAdmin = true;
                    }

                    if(group == 'Customer'){
                        this.Customer = true;
                    }

                    if(group == 'CustomerAdmin'){
                        this.CustomerAdmin = true;
                    }

                    if(group == 'ManagePrices'){
                        this.ManagePrices = true;
                    }

                    if(group == 'EditorGroup'){
                        this.EditorGroup = true;
                    }
                })
                if (!this.AdminUser && !this.InternalAdmin) {
                    alert("Access denied to dropbox dashboard")
                    // Redirect to the shipment page
                    this.$router.push('/ShipmentDashboard');
                }
            }
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
    },
    methods:{
        async CreateDriverItem(){
            // A vendor is required before a driver can be created.
            if (!this.driverInput.vendor?.trim()) {
                this.toggleAlertBox = true;
                this.alertMessage = "Please select a vendor before creating the driver.";
                return;
            }
            this.loadingUser = true;
            await this.createDriver();
            this.loadingUser = false;
        },
        async GetUserGraphQL(){
            this.loadingUser = true;
            try {
                let userReturnData = await API.graphql({
                    query: `query GetUser($userName: String!){
                        getUser(userName: $userName){
                        userName
                        accountNo
                        fullname
                        locationID
                        userEmail
                        locationAddress{
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                                }
                        }
                        }
                        labelImage
                    }
                    }`,
                    variables: {
                            userName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userData = userReturnData.data.getUser;
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to get user information"
            }finally{
                this.loadingUser = false;
            }
        },
        async generateDriverId() {
            const maxAttempts = 10;

            for (let attempt = 0; attempt < maxAttempts; attempt++) {
                const driverId = Math.floor(100000 + Math.random() * 900000);

                try {
                    const response = await API.graphql({
                        query: driverByDriverId,
                        variables: {
                            driverId
                        },
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    const existingDrivers =
                        response.data.driverByDriverId.items ?? [];

                    if (existingDrivers.length === 0) {
                        return driverId;
                    }
                } catch (error) {
                    console.error("Unable to validate Driver ID.", error);
                    throw error;
                }
            }

            throw new Error("Unable to generate a unique Driver ID.");
        },

        async createDriver() {
            this.loadingUser = true;

            try {
                const driverId = await this.generateDriverId();

                await API.graphql({
                    query: createDriver,
                    variables: {
                        input: {
                            driverCode: this.driverInput.driverCode,
                            firstName: this.driverInput.firstName,
                            lastName: this.driverInput.lastName,
                            email: this.driverInput.email,
                            phoneNumber:
                                this.driverInput.phoneNumber?.trim() || null,
                            vendor: this.driverInput.vendor?.trim() || null,
                            driverId
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });

                this.refreshKey++;
                this.loadingUser = false;
            } catch (error) {
                console.error("Unable to create driver.", error);

                this.toggleAlertBox = true;
                this.alertMessage = "Unable to create driver.";
                this.loadingUser = false;
            }
        },
        // Inline query that omits createdAt/updatedAt to avoid AWSDateTime null issues.
        async listVendors() {
            this.loadingVendors = true;

            let vendors = [];
            let nextToken = null;

            try {
                do {
                    const response = await API.graphql({
                        query: `query listVendors($nextToken: String) {
                            listVendors(limit: 1000, nextToken: $nextToken) {
                                items {
                                    vendor
                                    vendorName
                                }
                                nextToken
                            }
                        }`,
                        variables: {
                            nextToken
                        },
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    const data = response.data.listVendors;

                    vendors = vendors.concat(data.items || []);
                    nextToken = data.nextToken;
                } while (nextToken);

                vendors.sort((a, b) =>
                    (a.vendorName || a.vendor || "").localeCompare(
                        b.vendorName || b.vendor || ""
                    )
                );

                this.vendors = vendors;

                // Default the vendor to "LR" when it exists and nothing is selected yet.
                if (!this.driverInput.vendor) {
                    const lr = vendors.find((v) => v.vendor === "LR");
                    if (lr) this.driverInput.vendor = lr.vendor;
                }
            } catch (error) {
                console.error("Unable to list vendors.", error);
            } finally {
                this.loadingVendors = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        }
    }
}
</script>

<style scoped>
.st0{fill:none;stroke:#000000;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}

.cls-1 {
    fill: none;
    stroke: #3f3f3f;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 10px;
}

.cls-2 {
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 8px;
}

.cls-2-alt{
    stroke: #000;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 11px;
}

input, select{
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0,0,0,.336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
}


input[type=file]::file-selector-button {
    border: none;
    padding: 5px;
    border-radius: 15px;
    background-color: #32ccfe;
    transition: 1s;
    color: #fff;
    cursor: pointer;
}

input[type=file]::file-selector-button:hover {
    background-color: #2dbbeb;
    transition: 1s;
}

.confirmLabelContainer img{
    width: 50%;
    max-width: 150px;
    margin-top: 5px;
    border-radius: 5px;
}

.file-input{
    width: 80%;
}

html{
    background-color: #f3f3f3;
}

.main-container{
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inner-container{
    width: 70%;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 25px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.header-track-inner{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    background-color: #e2e2e2;
    padding: 5px 15px;
    border-radius: 999px;
}

.header-track-inner svg{
    height: 22px;
    margin: 0;
}

.header-track-shipment p{
    font-size: 18px;
    margin: 0;
    margin-left: 10px;
}

.header-track-shipment{
    width: 100%;
    margin-bottom: 5px;
}

.track-shipment{
    background-color: #fff;
    padding: 15px;
    border-radius: 25px;
    flex-basis: 25%;
    width: fit-content;
    height: fit-content;
    margin: 10px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.update-user{
    flex-basis: 60%;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

.user-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: left;
}

.user-info p{
    margin: 0;
}

.confirmContainerInner{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
    padding: 10px;
}

.auto-complete-container{
    margin-top: 5px !important;
    width: 90%;
    margin-left: 10px;
}

.update-user-button{
    background-color: #e4e4e4;
    color: #000;
    border: none;
    border-radius: 999px;
    padding: 5px 15px;
    width: fit-content;
    margin-top: 5px;
    margin-left: 10px;
    margin-bottom: 5px;
    transition-duration: .5s;
    cursor: pointer;
}

.update-user-button:hover{
    transition-duration: .5s;
    background-color: #d5d5d5;
}

@media only screen and (max-width: 1300px) {
    .inner-container{
        width: 85%;
    }
}

@media only screen and (max-width: 1000px) {
    .data-container-main, .inner-track-shipment-container{
        flex-wrap: wrap;
    }

    .track-shipment{
        flex-basis: 70%;
    }

    .data-container{
        flex-basis: 40%;
    }
}

@media only screen and (max-width: 600px) {
    .inner-container{
        width: 95%;
    }

    .data-container{
        flex-basis: 80%;
    }

    .track-shipment{
        flex-basis: 80%;
    }

    .confirmContainerInner{
        flex-wrap: wrap;
    }

    .notifications{
        margin-top: 5px;
    }
}
</style>